import { useLocation, Navigate, Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";

// const RequireAuth = ({ allowedRoles }) => {
//     const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails);
//     let location = useLocation();
//     let navigate = useNavigate()
//     // console.log("loginreducer>>>>>>>",loginreducer?.userType)
//     let Roles = []
//     if (loginreducer?.userType === "candidate") {
//         Roles = [1]
//     }
//     else if (loginreducer?.userType === "emp") {
//         Roles = [2]
//     }
//     // useEffect(() => {
//     //     if (location.key === "default") {
//     //         navigate("/unauthorized")
//     //     }
//     // }, []);
//     return (

//         Roles?.find(role => allowedRoles?.includes(role)) ? <Outlet /> :
//             <Navigate to="/unauthorized" state={{ from: location }} replace />


//     );
// }

// export default RequireAuth;
const RequireAuth = ({ allowedRoles }) => {
    const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails);
    let location = useLocation();
    let navigate = useNavigate();

    useEffect(() => {
        if (location.key === "default") {
            navigate("/");
        }
    }, [loginreducer]);

    let Roles = [];
    if (loginreducer?.userType === "candidate") {
        Roles = [1];
    } else if (loginreducer?.userType === "emp") {
        Roles = [2];
    }

    return (
        Roles?.find(role => allowedRoles?.includes(role)) ? <Outlet /> :
            <Navigate to="/unauthorized" state={{ from: location }} replace />
    );
};
export default RequireAuth;